import { Platform } from 'react-native';

import { getUserUuidFromAccessToken } from '../../biometric/accessTokenClaims';
import { analytics } from './analytics';

export type SignInMethod = 'password' | '2fa' | 'sso' | 'token_login' | 'biometric';

type SignInChannel = 'ios' | 'android' | 'web_mobile' | 'web_desktop';

const MOBILE_USER_AGENT = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

const getSignInChannel = (): SignInChannel => {
  if (Platform.OS === 'ios' || Platform.OS === 'android') return Platform.OS;
  const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  return MOBILE_USER_AGENT.test(userAgent) ? 'web_mobile' : 'web_desktop';
};

export const trackSignedIn = (
  method: SignInMethod,
  token: string,
  nextApp: string | undefined
): void => {
  analytics.trackEvent('auth_signed_in', {
    method,
    next_app: nextApp ?? null,
    channel: getSignInChannel(),
    user_uuid: getUserUuidFromAccessToken(token),
  });
};
